import React from 'react';
import { SIGNUP_URL } from '../engagementContent';

const CtaSection = ({
  title = 'Ready to hire your engagement manager?',
  description = 'They start working the day you connect your accounts. Free trial. No credit card. No new desk required.',
  ctaLabel = 'Get Started',
  signupUrl = SIGNUP_URL,
}) => {
  return (
    <section className="py-16 md:py-24 border-t border-[#c4ffa0]/25 bg-gradient-to-b from-[#f4fbf4] to-white">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black leading-snug">
          {title}
        </h2>
        <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">{description}</p>
        <a
          href={signupUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-flex items-center justify-center gap-2 h-12 md:h-14 px-8 md:px-12 rounded-full bg-[#8ae690] text-black font-semibold text-sm md:text-base shadow-md hover:bg-[#7ad67f] hover:shadow-lg transition-all duration-200"
        >
          <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/70">
            <img src="/kolanut_logo.png" alt="" className="w-4 h-4 object-contain" />
          </span>
          {ctaLabel}
        </a>
      </div>
    </section>
  );
};

export default CtaSection;
